<template>
<div class="investor-article">
    <Cover>
    </Cover>

    <InvestorBody>
        <div>

            <ol class="breadcrumb">
                <li>
                    <router-link :to="{name:'updates'}">Investor Articles</router-link>
                </li>
                <li>
                    {{investorArticle.title}}
                </li>
            </ol>
            <div class="article-header">
                <h2>{{ investorArticle.title }}</h2>

                <h3>{{ investorArticle.created | date}}</h3>
            </div>

            <div class="tiptap-content" v-html="investorArticle.html"></div>

        </div>
    </InvestorBody>

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import store from "@/store";
import Cover from "@/components/layout/Cover.vue";
import InvestorBody from "@/components/layout/InvestorBody.vue";
export default {
    name: "InvestorArticleView",

    components: {
        Cover,
        InvestorBody
    },

    beforeRouteEnter(to, from, next) {
        if (store.getters.user.is_investor == 't') {
            store.dispatch("loadInvestorArticle", to.params.slug).then(function () {
                next();
            })
        } else {
            next({
                name: "home"
            })
            return;
        }
    },

    beforeRouteUpdate(to, from, next) {
        if (store.getters.user.is_investor == 't') {
            store.dispatch("loadInvestorArticle", to.params.slug).then(function () {
                next();
            });
        } else {
            next({
                name: "home"
            })
            return;
        }
    },

    computed: {
        ...mapGetters(["investorArticle", "user"])
    },
};
</script>
